export default {"src":"/_next/static/media/chia-seeds.2f1b9090.svg","height":42,"width":66,"blurWidth":0,"blurHeight":0};